module.exports = __webpack_public_path__ + "static/Unilever-DSEP-ClassroomActivity-Virtual-1.5-PositiveThoughts_FR-078bb4c427bc981ea17e97a928045da1.pdf";